import React from "react";
import { House, Building, Briefcase, CircleCheck, ThermometerSun, Droplets, TrendingUp, ShieldCheck, Leaf } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
const benefitsList = [{
  title: "Cinematic 4K Flyovers",
  category: "Visuals",
  icon: TrendingUp,
  description: "Capture the sweeping majesty of your fairways with ultra-high-definition drone flyovers. Our cinematic approach highlights the unique topography and pristine conditions of your course, providing prospective members with an immersive preview of the experience."
}, {
  title: "Strategic Yardage Graphics",
  category: "Marketing",
  icon: ThermometerSun,
  description: "Enhance player engagement with professional-grade yardage and hazard overlays. We integrate precise graphics into our aerial footage, helping golfers visualize their strategy while showcasing the thoughtful design of your course's most challenging holes."
}, {
  title: "Clubhouse & Resort Media",
  category: "Hospitality",
  icon: Droplets,
  description: "Beyond the greens, we capture the luxury of your amenities. From grand clubhouse entrances to poolside relaxation areas, our interior and exterior videography tells the complete story of your resort's lifestyle and high-end hospitality offerings."
}, {
  title: "FAA Part 107 Compliance",
  category: "Safety",
  icon: House,
  description: "Operate with total peace of mind. Trow Solutions is fully FAA Part 107 certified and insured, ensuring that every flight over your property is conducted with the highest standards of safety, legality, and professional aviation etiquette."
}, {
  title: "Arizona Course Specialists",
  category: "Local Expertise",
  icon: Leaf,
  description: "We understand the unique lighting and landscape of Arizona golf. Whether it's the golden hour over a desert links or the lush greens of a mountain retreat, our local expertise ensures your course is captured in its most flattering, natural light."
}, {
  title: "Fast Turnaround Times",
  category: "Efficiency",
  icon: Briefcase,
  description: "In the fast-paced world of golf marketing, timing is everything. Our streamlined post-production workflow delivers high-impact media assets quickly, allowing you to launch seasonal campaigns or announce course updates without delay."
}, {
  title: "Strategic Marketing Assets",
  category: "Growth",
  icon: Building,
  description: "Our media isn't just beautiful—it's functional. We provide optimized content for social media, website headers, and television spots, specifically designed to increase membership inquiries and drive higher green fee revenue for your club."
}, {
  title: "Returning Client Discounts",
  category: "Partnership",
  icon: ShieldCheck,
  description: "We value long-term partnerships. Trow Solutions offers exclusive refresh discounts for returning clients, making it easy to keep your media library updated as your course matures, seasons change, or renovations are completed."
}];
export default function BeneficiosDeInstalarAerotermiaEnMirandaDeEbro() {
  return <section data-section-id="260795" id="whyprofessionalmedia" className="bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-8 text-foreground">
            Elevate Your Golf Course With Cinematic Aerial Media
          </h2>
          
          <div className="prose prose-lg dark:prose-invert mx-auto text-left text-muted-foreground space-y-6">
            <p className="font-serif italic text-xl text-primary">In an industry where first impressions are everything, static photography is no longer enough to capture the prestige of a world-class golf course. Trow Golf Media bridges the gap between traditional marketing and modern cinematic storytelling.</p>
            <p className="font-default">
              Professional drone flyovers, clubhouse videos, and strategic course visuals provide a perspective that ground-level photography simply cannot match. By showcasing the architectural intent of every hole and the luxury of your facilities from the air, we create an emotional connection with golfers before they even step onto the first tee. Our media serves as a powerful tool for country clubs and resorts looking to modernize their brand identity and attract a new generation of members.
            </p>
            <p className="font-default">
              Based in Arizona, we specialize in capturing the dramatic beauty of desert and mountain courses. Our team combines technical drone expertise with a deep understanding of golf course aesthetics, ensuring that every frame highlights the quality of your turf, the challenge of your hazards, and the elegance of your clubhouse. From 18-hole walkthroughs to high-impact social media clips, we deliver a comprehensive media suite that drives results.
            </p>
          </div>
        </div>

        <Separator className="my-16 border-secondary/30" />

        {}
        <div className="space-y-8">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h3 className="font-default text-2xl md:text-3xl font-semibold text-foreground mb-4">The Trow Golf Media Advantage</h3>
            <p className="text-muted-foreground font-default">
              Discover how our specialized aerial services transform your course's digital presence into a premium marketing powerhouse.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-8">
            {benefitsList.map((benefit, index) => {
            const Icon = benefit.icon;
            return <Card key={index} data-index={index} className="flex flex-col h-full shadow-md hover:shadow-xl transition-all duration-300 border-secondary/20 bg-card/50 backdrop-blur-sm">
                  <CardHeader className="pb-4">
                    <div className="flex justify-between items-start mb-4">
                      <div className="p-2.5 bg-secondary/10 rounded-lg text-secondary">
                        <Icon className="w-6 h-6" />
                      </div>
                      <Badge variant="secondary" className="font-medium bg-secondary/20 text-secondary-foreground border-none">
                        {benefit.category}
                      </Badge>
                    </div>
                    <CardTitle className="font-default text-xl leading-tight text-foreground">
                      <h4 className="font-default">{benefit.title}</h4>
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="text-muted-foreground text-sm leading-relaxed font-default">
                      {benefit.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>

      </div>
    </section>;
}